'use strict';

var GridToolbarSystemStatusMarketReoptDirective = function GridToolbarSystemStatusMarketReoptDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/grid-toolbar-system-status-market-reopt.html'),
    controller: 'GridToolbarSystemStatusMarketReoptController',
    link: function link(scope) {
      scope.$on('grid:rowSelectionChanged', function (event, selectedRows) {
        scope.onRowSelection(selectedRows);
      });
    }
  };
};
GridToolbarSystemStatusMarketReoptDirective.$inject = [];
module.exports = GridToolbarSystemStatusMarketReoptDirective;